import axios from 'axios'
import { Toast } from 'mint-ui'
const moment = require('moment')
// state
const state = {
    getUser: {},
    getSiteInfo: {},
    mine: {},
    address: [],
    tokenCard: {},
    getTouristUser: {},
    memberInfo: {},
    isPeerPriceShow: false,
    isPeerPrice: {is: false},
    inStoreNeedLogin: ''
}

// getters
const getters = {
    getUser: state => state.getUser,
    getSiteInfo: state => state.getSiteInfo,
    mine: state => state.mine,
    address: state => state.address,
    tokenCard: state => state.tokenCard,
    getTouristUser: state => state.getTouristUser,
    memberInfo: state => state.memberInfo,
    isPeerPrice: state => state.isPeerPrice,
    isPeerPriceShow: state => state.isPeerPriceShow,
    inStoreNeedLogin: state => state.inStoreNeedLogin
}

// actions
const actions = {
    getSaveUser ({ state, commit }, user) {
        return axios.get(
            '/ms/user/info'
        ).then(res => {
            commit('saveUserInfo', res.data.data)
        })
    },
    /* 请求店铺的会员信息 */
    async getMemberInfo ({state, commit}) {
        await axios.post('/store/member/info').then((res) => {
            if (res.data.status === 200) {
                let result = res.data.data
                if (result) {
                    if (!result.birth) {
                        result.birth = moment().format('YYYY-MM-DD')
                    } else {
                        result.birth = moment(result.birth).format('YYYY-MM-DD')
                    }
                    commit('saveMemberInfo', result)
                }
            } else if (res.data.status !== 100000) {
                Toast({ message: res.data.msg, position: 'bottom', duration: 1000 })
            } else if (res.data.status === 100000) {
                commit('storeNeedLogin', res.data.msg)
            }
        })
    },
    saveSiteInfo ({ state, commit }, params) {
        return axios.get(
            '/ms/baseInfo'
        ).then(res => {
            commit('saveSiteInfo', { getSiteInfo: res.data.data })
        })
    },
    addressRequest ({ state, commit }) {
        return axios.post(
            '/ms/user/searchfromcity', { parentId: 0 }
        ).then(res => {
            if (!res.data) return
            let address = res.data.data
            commit('change_address', { address })
            return address
        })
    },
    tokenCardUpload ({ state, commit }) {
        return axios.post(
            '/ms/user/picture/token'
        ).then(res => {
            commit('token_cardupload', { tokenCard: res.data })
        })
    }
}

// mutations
const mutations = {
    storeNeedLogin (state, value) {
        state.inStoreNeedLogin = value
    },
    setIsPeerPriceShow (state, value) {
        state.isPeerPriceShow = value
    },
    setIsPeerPrice (state, value) {
        let d = new Date()
        d.setHours(d.getHours() + 1)
        if (value) {
            state.isPeerPrice.is = true
            document.cookie = `isPeerPrice=1;path=/;expired=${new Date(d).toUTCString()}`
        } else {
            state.isPeerPrice.is = false
            document.cookie = `isPeerPrice=0;path=/;expired=${new Date(d).toUTCString()}`
        }
    },
    saveMemberInfo (state, value) {
        if (value.birth) {
            value.birth = moment(value.birth).format('YYYY-MM-DD')
        }
        state.memberInfo = value
    },
    saveUserInfo (state, value) {
        console.log('saveUserInfo')
        state.getUser = value || {}
    },
    saveSiteInfo (state, { getSiteInfo }) {
        state.getSiteInfo = getSiteInfo || {}
    },
    change_address (state, { address }) {
        state.address = address
    },
    token_cardupload (state, { tokenCard }) {
        state.tokenCard = tokenCard || {}
    },
    saveTouristUser (state, value) {
        state.getTouristUser = value || {}
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js